<template>
  <ConfigErrorBoundary>
    <FileConverter :config="converterConfig" @batch-created="handleBatchCreated" @job-completed="handleJobCompleted" @batch-cleared="handleBatchCleared" @error="handleError" @credits-updated="handleCreditsUpdated" />
  </ConfigErrorBoundary>
</template>
<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';
const converterConfig = parseAndValidateConverterConfig('dng-to-avif-converter', 'Adobe DNG → AVIF');
function handleBatchCreated(batchId: string) { console.log('[DNG to AVIF] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[DNG to AVIF] Job completed:', jobId); }
function handleBatchCleared() { console.log('[DNG to AVIF] Batch cleared'); }
function handleError(error: Error) { console.error('[DNG to AVIF] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[DNG to AVIF] Credits updated:', credits); }
</script>
